import React, { useCallback } from 'react';
import { trimStart } from 'lodash';
import './SlideoutAddForm.scss';
import TextInput from '../../../../../common/components/TextInput';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';

type Props = {
  onAdd?: (e: string) => any;
  placeholder?: string;
};

export const SlideoutAddForm = ({ placeholder, onAdd }: Props) => {
  const onSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const input =
        e.currentTarget.querySelector<HTMLInputElement>('[name="name"]');
      if (input && input.value) {
        onAdd && onAdd(input.value.trim());
        input.value = '';
      }
    },
    [onAdd],
  );

  const onInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    e.currentTarget.value = trimStart(e.currentTarget.value);
  }, []);

  return (
    <form className="slideout-add-form" onSubmit={onSubmit}>
      <TextInput
        className="slideout-add-form__input"
        name="name"
        value={undefined}
        autoFocus={true}
        onInput={onInput}
        autoComplete="false"
        placeholder={placeholder}
      />
      <Button lightGray className="slideout-add-form__btn">
        Add
      </Button>
    </form>
  );
};
